import BrandAchievements from 'components/BrandHistory/BrandAchievements'
import BrandAchievementCreator from 'components/BrandHistory/BrandAchievementItem'
import BrandReviews from 'components/BrandHistory/BrandReviews'
import BrandReviewCreator from 'components/BrandHistory/BrandReviewItem'
import BrandRecommendations from 'components/BrandHistory/BrandRecommendations'
import RecommendationLetterCreator from 'components/BrandHistory/RecommendationLetterItem'
import BrokerageHouseCreator from 'components/BrandHistory/BrokerageHouseItem'

export default {
  children: [
    {
      path: 'reviews',
      name: 'BrandReviews',
      component: BrandReviews
    }, {
      path: 'reviews/new',
      name: 'BrandReviewCreator',
      component: BrandReviewCreator
    }, {
      path: 'recommendations',
      name: 'BrandRecommendations',
      component: BrandRecommendations
    }, {
      path: 'recomandations/new-letter',
      name: 'RecommendationLetterCreator',
      component: RecommendationLetterCreator
    }, {
      path: 'recomandations/new-house',
      name: 'BrokerageHouseCreator',
      component: BrokerageHouseCreator
    }, {
      path: 'achievements',
      name: 'BrandAchievements',
      component: BrandAchievements
    }, {
      path: 'achievements/new',
      name: 'BrandAchievementCreator',
      component: BrandAchievementCreator
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/HistoryRoutes.js